import OrderState from '~/constants/home/orderState';
import { useGetVehicleDetails } from '~/context/vdp/VehicleContext';
import useUserPurchasing from './useUserPurchasing';
import useIsInSptOnVdpExperiment from '../useIsInSptOnVdpExperiment';

export default function useShouldDisplayOrderStatus() {
  const isInSptOnVdpExperiment = useIsInSptOnVdpExperiment();
  const { orderState, vehicle: { vehicleId: purchasingVehicleId = 0 } = {} } =
    useUserPurchasing();
  const { vehicleId: currentVehicleId = 0 } = useGetVehicleDetails();

  return (
    isInSptOnVdpExperiment &&
    purchasingVehicleId === currentVehicleId &&
    orderState !== OrderState.Reserved
  );
}
